// import React, { useEffect, useState } from "react";
// import { Form, Row, Col } from "react-bootstrap";
// import { useParams } from "react-router-dom";
// import useFetchRoutes from "../../hooks/useFetchRoutes ";
// import useFeeGroups from "../../hooks/useFeeGroups";
// import useFetchPickupPoints from "../../hooks/useFetchPickupPoints ";
// import { ApiUrl } from "../../../ApiUrl";

// const DesignComponent = ({ formData, setFormData }) => {
//   const { id } = useParams();
//   const [isTransportAvailed, setIsTransportAvailed] = useState(() => {
//     const saved = localStorage.getItem("transportAvailed");
//     return saved === "true";
//   });
//   const [periods, setPeriods] = useState([]);
//   const [error, setError] = useState(null);
//   const [selectedMonths, setSelectedMonths] = useState(() => {
//     const saved = localStorage.getItem("selectedMonths");
//     return saved ? JSON.parse(saved) : {};
//   });

//   const [selectedRoute, setSelectedRoute] = useState("");
//   const [selectedPickUpPoint, setSelectedPickUpPoint] = useState("");
//   const [isDisabled, setIsDisabled] = useState(false);

//   const {
//     routes,
//     loading: routeLoading,
//     error: routeError,
//   } = useFetchRoutes(isTransportAvailed);
//   const {
//     pickupPoints,
//     loading: pickupLoading,
//     error: pickupError,
//   } = useFetchPickupPoints(selectedRoute);

//   const [selectedClassId, setSelectedClassId] = useState(null);
//   const {
//     feeGroups = [],
//     loading: feeLoading,
//     error: feeError,
//   } = useFeeGroups(selectedClassId);

//   useEffect(() => {
//     const storedClassId = localStorage.getItem("selectedClassId");
//     if (storedClassId) setSelectedClassId(storedClassId);
//   }, []);

//   useEffect(() => {
//     if (id) {
//       fetch(
//         `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
//       )
//         .then((res) => res.json())
//         .then((data) => {
//           if (data.message === "success" && data.data?.fee_details) {
//             const { feegroupId, periodId } = data.data.fee_details;
//             setFormData((prevData) => ({
//               ...prevData,
//               feegroup: feegroupId || "",
//               feeappfrom: periodId || "",
//             }));
//             setIsDisabled(true);
//           }
//         })
//         .catch((err) =>
//           console.error("Error fetching student fee details:", err)
//         );
//     }
//   }, [id]);

//   useEffect(() => {
//     fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`)
//       .then((response) =>
//         response.ok ? response.json() : Promise.reject(response.status)
//       )
//       .then((data) => {
//         const allPeriods = data.data || [];
//         setPeriods(allPeriods);

//         const initialMonths = allPeriods.reduce((acc, period) => {
//           acc[period.id] = formData.choice_month?.includes(period.id) || false;
//           return acc;
//         }, {});
//         setSelectedMonths(initialMonths);
//       })
//       .catch(() => setError("Failed to load periods."));
//   }, [formData.choice_month]);

//   useEffect(() => {
//     localStorage.setItem("transportFormData", JSON.stringify(formData));
//   }, [formData]);

//   useEffect(() => {
//     const savedFormData = localStorage.getItem("transportFormData");
//     if (savedFormData) {
//       setFormData(JSON.parse(savedFormData));
//     }
//   }, []);

//   useEffect(() => {
//     const wasPageRefreshed = performance.navigation.type === 1;

//     if (wasPageRefreshed) {
//       const storedRouteId = localStorage.getItem("selectedRouteId");
//       const storedPickupPointId = localStorage.getItem("selectedPickupPointId");

//       if (storedRouteId) {
//         setSelectedRoute(storedRouteId);
//         setFormData((prevData) => ({
//           ...prevData,
//           route_id: storedRouteId,
//         }));
//       }

//       if (storedPickupPointId) {
//         setSelectedPickUpPoint(storedPickupPointId);
//         setFormData((prevData) => ({
//           ...prevData,
//           route_details: storedPickupPointId,
//         }));
//       }
//     } else {
//       const storedRouteId = sessionStorage.getItem("selectedRouteId");
//       const storedPickupPointId = sessionStorage.getItem(
//         "selectedPickupPointId"
//       );

//       if (storedRouteId) {
//         setSelectedRoute(storedRouteId);
//         setFormData((prevData) => ({
//           ...prevData,
//           route_id: storedRouteId,
//         }));
//       }

//       if (storedPickupPointId) {
//         setSelectedPickUpPoint(storedPickupPointId);
//         setFormData((prevData) => ({
//           ...prevData,
//           route_details: storedPickupPointId,
//         }));
//       }
//     }
//   }, []);

//   const handleTransportAvailedChange = (e) => {
//     if (isDisabled) return;
//     const newValue = e.target.checked;
//     setIsTransportAvailed(newValue);
//     localStorage.setItem("transportAvailed", newValue);

//     const updatedMonths = Object.keys(selectedMonths).reduce((acc, month) => {
//       acc[month] = newValue;
//       return acc;
//     }, {});
//     setSelectedMonths(updatedMonths);
//     localStorage.setItem("selectedMonths", JSON.stringify(updatedMonths));

//     const selectedMonthIds = Object.keys(updatedMonths)
//       .filter((month) => updatedMonths[month])
//       .map((month) => parseInt(month));

//     setFormData((prevData) => ({
//       ...prevData,
//       transport_availed: newValue,
//       choice_month: selectedMonthIds,
//     }));
//   };

//   const handleInputChange = (e) => {
//     if (isDisabled) return;
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handlePickUpPointChange = (e) => {
//     if (isDisabled) return;
//     const selectedPickupPointId = e.target.value;
//     setSelectedPickUpPoint(selectedPickupPointId);

//     const selectedPickupObj = pickupPoints.find(
//       (point) => point.routeDetailsId.toString() === selectedPickupPointId
//     );
//     const selectedPickupName = selectedPickupObj?.pickup_point_name || "";

//     sessionStorage.setItem("selectedPickupPointId", selectedPickupPointId);
//     sessionStorage.setItem("selectedPickupPointName", selectedPickupName);
//     localStorage.setItem("selectedPickupPointId", selectedPickupPointId);
//     localStorage.setItem("selectedPickupPointName", selectedPickupName);

//     setFormData((prevData) => ({
//       ...prevData,
//       route_details: selectedPickupPointId,
//     }));
//   };

//   const handleRouteChange = (e) => {
//     if (isDisabled) return;
//     const selectedRouteId = e.target.value;
//     setSelectedRoute(selectedRouteId);

//     const selectedRouteObj = routes.find(
//       (route) => route.id.toString() === selectedRouteId
//     );
//     const selectedRouteName = selectedRouteObj?.transportname || "";

//     sessionStorage.setItem("selectedRouteId", selectedRouteId);
//     sessionStorage.setItem("selectedRouteName", selectedRouteName);
//     localStorage.setItem("selectedRouteId", selectedRouteId);
//     localStorage.setItem("selectedRouteName", selectedRouteName);

//     setFormData((prevData) => ({
//       ...prevData,
//       route_id: selectedRouteId,
//     }));
//   };

//   const handleMonthChange = (monthId) => {
//     if (isDisabled) return;
//     const updatedMonths = {
//       ...selectedMonths,
//       [monthId]: !selectedMonths[monthId],
//     };
//     setSelectedMonths(updatedMonths);
//     localStorage.setItem("selectedMonths", JSON.stringify(updatedMonths));

//     const selectedMonthIds = Object.keys(updatedMonths)
//       .filter((month) => updatedMonths[month])
//       .map((month) => parseInt(month));

//     setFormData((prevData) => ({
//       ...prevData,
//       choice_month: selectedMonthIds.length > 0 ? selectedMonthIds : null,
//     }));
//   };

//   return (
//     <div className="container-fluid">
//       <div className="row mt-3 mx-2">
//         <div className="col-12 custom-section-box">
//           <div className="row">
//             <div className="col-12 border">
//               <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
//                 <div className="row flex-grow-1 mt-2">
//                   <div className="col-12 col-md-6 mb-4">
//                     <label htmlFor="fee-app-from" className="form-label">
//                       Fee App From<span style={{ color: "red" }}>*</span>
//                     </label>
//                     {error ? (
//                       <p style={{ color: "red" }}>{error}</p>
//                     ) : (
//                       <select
//                         id="fee-app-from"
//                         className="detail"
//                         value={formData.feeappfrom}
//                         onChange={handleInputChange}
//                         name="feeappfrom"
//                         disabled={isDisabled}
//                       >
//                         <option value="">Select period</option>
//                         {periods.map((period) => (
//                           <option key={period.id} value={period.id}>
//                             {period.period_name}
//                           </option>
//                         ))}
//                       </select>
//                     )}
//                   </div>
//                   <div className="col-12 col-md-6 mb-2">
//                     <label htmlFor="fee-group" className="form-label">
//                       Fee Group<span style={{ color: "red" }}>*</span>
//                     </label>
//                     {feeLoading ? (
//                       <p>Loading fee groups...</p>
//                     ) : (
//                       <select
//                         id="fee-group"
//                         className="detail"
//                         value={formData.feegroup}
//                         onChange={handleInputChange}
//                         name="feegroup"
//                         disabled={
//                           isDisabled || feeError || feeGroups.length === 0
//                         }
//                       >
//                         <option value="">
//                           {feeError || feeGroups.length === 0
//                             ? "No fee groups available"
//                             : "Select Fee Group"}
//                         </option>
//                         {feeGroups.map((feeGroup) => (
//                           <option key={feeGroup.id} value={feeGroup.id}>
//                             {feeGroup.feestructuredesc}
//                           </option>
//                         ))}
//                       </select>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <Form.Check
//             type="checkbox"
//             label="Transport Availed"
//             className="mb-3"
//             style={{ fontWeight: "700" }}
//             checked={isTransportAvailed}
//             onChange={handleTransportAvailedChange}
//             disabled={isDisabled}
//           />

//           <Row>
//             {Object.keys(selectedMonths).map((monthId) => (
//               <Col xs={3} sm={2} md={1} key={monthId} className="mb-4">
//                 <Form.Check
//                   type="checkbox"
//                   id={`month-checkbox-${monthId}`}
//                   label={
//                     periods.find((period) => period.id === parseInt(monthId))
//                       ?.period_name || `Month ${monthId}`
//                   }
//                   checked={selectedMonths[monthId] || false}
//                   onChange={() => handleMonthChange(monthId)}
//                   disabled={!isTransportAvailed || isDisabled}
//                 />
//               </Col>
//             ))}
//           </Row>

//           <Row className="mt-3">
//             <Col md={6} className="mb-4">
//               <Form.Group controlId="formRoute">
//                 <Form.Label>Route</Form.Label>
//                 <Form.Select
//                   value={selectedRoute}
//                   onChange={handleRouteChange}
//                   className="detail"
//                   disabled={!isTransportAvailed || isDisabled}
//                 >
//                   <option>Select</option>
//                   {routeLoading && <option>Loading...</option>}
//                   {routeError && <option>Error loading routes</option>}
//                   {!routeLoading &&
//                     !routeError &&
//                     routes.map((route) => (
//                       <option key={route.id} value={route.id}>
//                         {route.transportname}
//                       </option>
//                     ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             <Col md={6} className="mb-2">
//               <Form.Group controlId="formPickUpPoint">
//                 <Form.Label>Pick Up Point</Form.Label>
//                 <Form.Select
//                   value={selectedPickUpPoint}
//                   onChange={handlePickUpPointChange}
//                   className="detail"
//                   disabled={!isTransportAvailed || !selectedRoute || isDisabled}
//                 >
//                   <option>Select</option>
//                   {pickupLoading && <option>Loading...</option>}
//                   {pickupError && <option>Error loading pick-up points</option>}
//                   {!pickupLoading && !pickupError && pickupPoints.length > 0 ? (
//                     pickupPoints.map((pickupPoint) => (
//                       <option
//                         key={pickupPoint.routeDetailsId}
//                         value={pickupPoint.routeDetailsId}
//                       >
//                         {pickupPoint.pickup_point_name}
//                       </option>
//                     ))
//                   ) : (
//                     <option value="" disabled>
//                       No pick-up points available
//                     </option>
//                   )}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DesignComponent;

import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import useFetchRoutes from "../../hooks/useFetchRoutes ";
import useFeeGroups from "../../hooks/useFeeGroups";
import useFetchPickupPoints from "../../hooks/useFetchPickupPoints ";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";

const DesignComponent = ({ formData, setFormData }) => {
  const { id } = useParams();

  // Force blank values on initial render
  const [isTransportAvailed, setIsTransportAvailed] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState({});
  const [selectedRoute, setSelectedRoute] = useState("");
  const [selectedPickUpPoint, setSelectedPickUpPoint] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [periods, setPeriods] = useState([]);
  const [error, setError] = useState(null);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  useEffect(() => {
    const transportEnabled = Boolean(formData.transport_availed);
    setIsTransportAvailed(transportEnabled);

    if (!transportEnabled) {
      setSelectedMonths((prev) => {
        const resetMonths = {};
        Object.keys(prev).forEach((monthId) => {
          resetMonths[monthId] = false;
        });
        return resetMonths;
      });
      setSelectedRoute("");
      setSelectedPickUpPoint("");
      return;
    }

    if (periods.length > 0) {
      const selectedMonthIds = Array.isArray(formData.choice_month)
        ? formData.choice_month.map((monthId) => Number(monthId))
        : [];

      const restoredMonths = periods.reduce((acc, period) => {
        acc[period.id] = selectedMonthIds.includes(period.id);
        return acc;
      }, {});

      setSelectedMonths(restoredMonths);
    }

    setSelectedRoute(formData.route_id ? String(formData.route_id) : "");
    setSelectedPickUpPoint(
      formData.route_details ? String(formData.route_details) : ""
    );
  }, [formData.transport_availed, formData.choice_month, formData.route_id, formData.route_details, periods]);

  // 🔄 Reset local transport state when parent formData is cleared
  useEffect(() => {
    if (!formData.transport_availed) {
      setIsTransportAvailed(false);
      setSelectedMonths((prev) => {
        const resetMonths = {};
        Object.keys(prev).forEach((monthId) => {
          resetMonths[monthId] = false; // uncheck all
        });
        return resetMonths;
      });
      setSelectedRoute("");
      setSelectedPickUpPoint("");
    }
  }, [formData.transport_availed]);

  const {
    routes,
    loading: routeLoading,
    error: routeError,
  } = useFetchRoutes(isTransportAvailed);

  const {
    pickupPoints,
    loading: pickupLoading,
    error: pickupError,
  } = useFetchPickupPoints(selectedRoute);

  // const {
  //   feeGroups = [],
  //   loading: feeLoading,
  //   error: feeError,
  // } = useFeeGroups(selectedClassId || selectedCategoryId);

  const {
    feeGroups = [],
    loading: feeLoading,
    error: feeError,
  } = useFeeGroups(selectedClassId, selectedCategoryId);

  useEffect(() => {
    const storedClassId = localStorage.getItem("selectedClassId");
    const storedCategoryId = localStorage.getItem("selectedCategoryId");

    if (storedClassId) setSelectedClassId(storedClassId);
    if (storedCategoryId) setSelectedCategoryId(storedCategoryId);
  }, []);

  // inside DesignComponent

  useEffect(() => {
    if (formData.addmitted_class) {
      setSelectedClassId(formData.addmitted_class);
      localStorage.setItem("selectedClassId", formData.addmitted_class); // keep in sync
    } else {
      setSelectedClassId(null);
      localStorage.removeItem("selectedClassId");
    }
  }, [formData.addmitted_class]);

  useEffect(() => {
    if (id) {
      fetch(
        `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.message === "success" && data.data?.fee_details) {
            const { feegroupId, periodId } = data.data.fee_details;
            setFormData((prevData) => ({
              ...prevData,
              feegroup: feegroupId || "",
              feeappfrom: periodId || "",
            }));
            setIsDisabled(true);
          }
        })
        .catch((err) =>
          console.error("Error fetching student fee details:", err)
        );
    }
  }, [id]);

  // 08212025 new code
  // useEffect(() => {
  //   if (id) {
  //     fetch(
  //       `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
  //     )
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.message === "success" && data.data) {
  //           const { fee_details } = data.data;
  //           const { feegroupId, periodId } = fee_details || {};

  //           setFormData((prevData) => ({
  //             ...prevData,
  //             feegroup: feegroupId || "",
  //             feeappfrom: periodId || "",
  //             transport_availed: data.data.transport_availed || false,
  //             choice_month: data.data.choice_month || [],
  //             route_id: data.data.routeid || "",
  //             route_details: data.data.pickuppoitId || ""
  //           }));

  //           // ✅ sync UI states
  //           setIsTransportAvailed(data.data.transport_availed || false);
  //           setSelectedRoute(data.data.routeid || "");
  //           setSelectedPickUpPoint(data.data.pickuppoitId || "");

  //           // ✅ reset selectedMonths properly
  //           const updatedMonths = periods.reduce((acc, p) => {
  //             acc[p.id] = data.data.choice_month?.includes(p.id) || false;
  //             return acc;
  //           }, {});
  //           setSelectedMonths(updatedMonths);

  //           setIsDisabled(true);
  //         }
  //       })
  //       .catch((err) =>
  //         console.error("Error fetching student fee details:", err)
  //       );
  //   }
  // }, [id, periods]);

  useEffect(() => {
    const periodQuery = new URLSearchParams();
    const academicYearId = localStorage.getItem("academicSessionId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");

    if (academicYearId) periodQuery.append("academic_year_id", academicYearId);
    if (orgId) periodQuery.append("org_id", orgId);
    if (branchId) periodQuery.append("branch_id", branchId);

    fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/?${periodQuery.toString()}`)
      .then((response) =>
        response.ok ? response.json() : Promise.reject(response.status)
      )
      .then((data) => {
        const allPeriods = data.data || [];
        setPeriods(allPeriods);

        const initialMonths = allPeriods.reduce((acc, period) => {
          acc[period.id] = false;
          return acc;
        }, {});
        setSelectedMonths(initialMonths);
      })
      .catch(() => setError("Failed to load periods."));
  }, []);

  // const handleTransportAvailedChange = (e) => {
  //   if (isDisabled) return;
  //   const newValue = e.target.checked;
  //   setIsTransportAvailed(newValue);

  //   const updatedMonths = Object.keys(selectedMonths).reduce((acc, month) => {
  //     acc[month] = newValue;
  //     return acc;
  //   }, {});
  //   setSelectedMonths(updatedMonths);

  //   const selectedMonthIds = Object.keys(updatedMonths)
  //     .filter((month) => updatedMonths[month])
  //     .map((month) => parseInt(month));

  //   setFormData((prevData) => ({
  //     ...prevData,
  //     transport_availed: newValue,
  //     choice_month: selectedMonthIds,
  //     route_id: "",
  //     route_details: "",
  //   }));

  //   setSelectedRoute("");
  //   setSelectedPickUpPoint("");
  // };

  const handleTransportAvailedChange = (e) => {
    if (isDisabled) return;

    const newValue = e.target.checked;
    setIsTransportAvailed(newValue);

    // Update selected months when transport is availed
    const updatedMonths = Object.keys(selectedMonths).reduce((acc, month) => {
      acc[month] = newValue;
      return acc;
    }, {});
    setSelectedMonths(updatedMonths);

    const selectedMonthIds = Object.keys(updatedMonths)
      .filter((month) => updatedMonths[month])
      .map((month) => parseInt(month));

    setFormData((prevData) => ({
      ...prevData,
      transport_availed: newValue, // ✅ updated here immediately
      choice_month: selectedMonthIds.length > 0 ? selectedMonthIds : [],
      route_id: "",
      route_details: "",
    }));

    // Reset dependent states
    setSelectedRoute("");
    setSelectedPickUpPoint("");
  };

  const handleInputChange = (e) => {
    if (isDisabled) return;
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRouteChange = (e) => {
    if (isDisabled) return;
    const selectedRouteId = e.target.value;
    setSelectedRoute(selectedRouteId);
    setFormData((prevData) => ({
      ...prevData,
      route_id: selectedRouteId,
    }));
  };

  const handlePickUpPointChange = (e) => {
    if (isDisabled) return;
    const selectedPickupPointId = e.target.value;
    setSelectedPickUpPoint(selectedPickupPointId);
    setFormData((prevData) => ({
      ...prevData,
      route_details: selectedPickupPointId,
    }));
  };

  const handleMonthChange = (monthId) => {
    if (isDisabled) return;
    const updatedMonths = {
      ...selectedMonths,
      [monthId]: !selectedMonths[monthId],
    };
    setSelectedMonths(updatedMonths);

    const selectedMonthIds = Object.keys(updatedMonths)
      .filter((month) => updatedMonths[month])
      .map((month) => parseInt(month));

    setFormData((prevData) => ({
      ...prevData,
      choice_month: selectedMonthIds.length > 0 ? selectedMonthIds : null,
    }));
  };

  // 🔄 Watch category changes
  useEffect(() => {
    if (formData.category) {
      setSelectedCategoryId(formData.category);
      localStorage.setItem("selectedCategoryId", formData.category); // keep in sync
    } else {
      setSelectedCategoryId(null);
      localStorage.removeItem("selectedCategoryId");
    }
  }, [formData.category]);

  const hasFeeGroupPrerequisites = Boolean(
    formData.addmitted_class || selectedClassId
  );

  return (
    <div className="container-fluid">
      <div className="row mt-3 mx-2">
        <div className="col-12 custom-section-box">
          <div className="row">
            <div className="col-12 border">
              <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                <div className="row flex-grow-1 mt-2">
                  <div className="col-12 col-md-6 mb-4">
                    <label htmlFor="fee-app-from" className="form-label">
                      Fee App From<span style={{ color: "red" }}>*</span>
                    </label>

                    <Select
                      id="fee-app-from"
                      name="feeappfrom"
                      className="detail"
                      classNamePrefix="feeappfrom-dropdown"
                      placeholder="Select period"
                      options={periods.map((period) => ({
                        value: period.id,
                        label: period.period_name,
                      }))}
                      value={
                        formData.feeappfrom
                          ? {
                              value: formData.feeappfrom,
                              label:
                                periods.find(
                                  (p) => p.id === formData.feeappfrom
                                )?.period_name || formData.feeappfrom,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleInputChange({
                          target: {
                            name: "feeappfrom",
                            value: selectedOption?.value || "",
                          },
                        })
                      }
                      isDisabled={isDisabled}
                    />
                  </div>
                  {/* <div className="col-12 col-md-6 mb-2">
                    <label htmlFor="fee-group" className="form-label">
                      Fee Group<span style={{ color: "red" }}>*</span>
                    </label>
                    {feeLoading ? (
                      <p>Loading fee groups...</p>
                    ) : (
                      <select
                        id="fee-group"
                        className="detail"
                        value={formData.feegroup}
                        onChange={handleInputChange}
                        name="feegroup"
                        disabled={
                          isDisabled ||
                          feeError ||
                          feeGroups.length === 0 ||
                          (sessionStorage.getItem("ClassLogic") !== "true" &&
                            sessionStorage.getItem("CategoryLogic") !== "true")
                        }
                      >
                        <option value="">
                          {feeError || feeGroups.length === 0
                            ? "No fee groups available"
                            : "Select Fee Group"}
                        </option>
                        {feeGroups.map((feeGroup) => (
                          <option key={feeGroup.id} value={feeGroup.id}>
                            {feeGroup.feestructuredesc}
                          </option>
                        ))}
                      </select>
                    )}
                  </div> */}
                  <div className="col-12 col-md-6 mb-2">
                    <label htmlFor="fee-group" className="form-label">
                      Fee Group<span style={{ color: "red" }}>*</span>
                    </label>

                    <Select
                      id="fee-group"
                      name="feegroup"
                      className="detail"
                      classNamePrefix="feegroup-dropdown"
                      placeholder="Select Fee Group"
                      noOptionsMessage={() => {
                        if (!hasFeeGroupPrerequisites) {
                          return "Select class first";
                        }
                        if (feeLoading) {
                          return "Loading fee groups...";
                        }
                        if (feeError) {
                          return "Failed to load fee groups";
                        }
                        return "No fee groups available";
                      }}
                      options={feeGroups.map((feeGroup) => ({
                        value: feeGroup.id,
                        label: feeGroup.feestructuredesc,
                      }))}
                      value={
                        formData.feegroup
                          ? {
                              value: formData.feegroup,
                              label:
                                feeGroups.find(
                                  (fg) => fg.id === formData.feegroup
                                )?.feestructuredesc || formData.feegroup,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleInputChange({
                          target: {
                            name: "feegroup",
                            value: selectedOption?.value || "",
                          },
                        })
                      }
                      isDisabled={
                        isDisabled ||
                        !hasFeeGroupPrerequisites ||
                        feeLoading ||
                        !!feeError
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <Form.Check
            type="checkbox"
            label="Transport Availed"
            className="mb-3"
            style={{ fontWeight: "700" }}
            checked={isTransportAvailed}
            onChange={handleTransportAvailedChange}
            disabled={isDisabled}
          /> */}
          <Form.Check
            type="checkbox"
            label="Transport Availed"
            className="mb-3"
            style={{ fontWeight: "700" }}
            checked={isTransportAvailed}
            onChange={handleTransportAvailedChange}
            disabled={isDisabled}
          />

          <Row>
            {Object.keys(selectedMonths).map((monthId) => (
              <Col xs={3} sm={2} md={1} key={monthId} className="mb-4">
                <Form.Check
                  type="checkbox"
                  id={`month-checkbox-${monthId}`}
                  label={
                    periods.find((period) => period.id === parseInt(monthId))
                      ?.period_name || `Month ${monthId}`
                  }
                  checked={selectedMonths[monthId] || false}
                  onChange={() => handleMonthChange(monthId)}
                  disabled={!isTransportAvailed || isDisabled}
                />
              </Col>
            ))}
          </Row>

          <Row className="mt-3">
            <Col md={6} className="mb-4">
              <Form.Group controlId="formRoute">
                <Form.Label>Route</Form.Label>
                <Form.Select
                  value={selectedRoute}
                  onChange={handleRouteChange}
                  className="detail"
                  disabled={!isTransportAvailed || isDisabled}
                >
                  <option value="">Select</option>
                  {routeLoading && <option>Loading...</option>}
                  {routeError && <option>Error loading routes</option>}
                  {!routeLoading &&
                    !routeError &&
                    routes.map((route) => (
                      <option key={route.id} value={route.id}>
                        {route.transportname}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Group controlId="formPickUpPoint">
                <Form.Label>Pick Up Point</Form.Label>
                <Form.Select
                  value={selectedPickUpPoint}
                  onChange={handlePickUpPointChange}
                  className="detail"
                  disabled={!isTransportAvailed || !selectedRoute || isDisabled}
                >
                  <option value="">Select</option>
                  {pickupLoading && <option>Loading...</option>}
                  {pickupError && <option>Error loading pick-up points</option>}
                  {!pickupLoading && !pickupError && pickupPoints.length > 0 ? (
                    pickupPoints.map((pickupPoint) => (
                      <option
                        key={pickupPoint.routeDetailsId}
                        value={pickupPoint.routeDetailsId}
                      >
                        {pickupPoint.pickup_point_name}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      No pick-up points available
                    </option>
                  )}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default DesignComponent;
